import { stripTimeFromDate } from '../../../../shared/utils';
import { LogDateCountDTO } from '../dtos/LogDateCount.dto';
import { LogDateCountModel } from '../models/LogDateCount.model';
import { ChartDataType } from '../types/AnalyticsTypes';

export class LogDateCountUtil {
  public static mapToViewModel(dto: LogDateCountDTO): LogDateCountModel {
    return {
      date: dto.date,
      count: dto.count,
    };
  }

  public static mapToChartData(
    logDateCount: LogDateCountModel,
  ): ChartDataType<number> {
    return {
      label: stripTimeFromDate(new Date(logDateCount.date), true),
      value: logDateCount.count,
    };
  }
}
